interface CheckProgressProps {
  domains: string[];
  onCancel: () => void;
}

export function CheckProgress({ domains, onCancel }: CheckProgressProps) {
  return (
    <div className="mx-auto max-w-2xl space-y-6">
      <div className="text-center">
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
          Checking Availability
        </h2>
        <p className="mt-2 text-gray-600 dark:text-gray-400">
          Performing DNS and RDAP lookups for {domains.length} domain
          {domains.length === 1 ? '' : 's'}...
        </p>
      </div>

      {/* Progress indicator */}
      <div className="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm dark:border-gray-700 dark:bg-gray-900">
        {/* Animated progress bar */}
        <div className="h-1 w-full overflow-hidden bg-gray-100 dark:bg-gray-800">
          <div className="h-full w-1/3 animate-[progress_1.5s_ease-in-out_infinite] rounded-full bg-blue-600" />
        </div>

        <ul className="divide-y divide-gray-100 dark:divide-gray-800">
          {domains.map((domain) => (
            <li
              key={domain}
              className="flex items-center gap-3 px-4 py-3"
            >
              {/* Spinner */}
              <svg
                className="h-4 w-4 animate-spin text-blue-600 dark:text-blue-400"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                />
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                />
              </svg>
              <span className="font-mono text-sm text-gray-700 dark:text-gray-300">
                {domain}
              </span>
            </li>
          ))}
        </ul>
      </div>

      <div className="text-center">
        <button
          type="button"
          onClick={onCancel}
          className="rounded-lg border border-gray-300 bg-white px-6 py-2.5 text-sm font-medium text-gray-700 shadow-sm transition-colors hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700 dark:focus-visible:ring-offset-gray-950"
        >
          Cancel
        </button>
      </div>

      <style>{`
        @keyframes progress {
          0% { transform: translateX(-100%); }
          50% { transform: translateX(200%); }
          100% { transform: translateX(-100%); }
        }
      `}</style>
    </div>
  );
}
